
export class ProductFilterOptions {
    productIds: Array<number>;
    platformIds: Array<number>;
    leadSMEIds: Array<number>;
    serviceIds: Array<number>;
}
